interface MaskStyleShape {
  url: string
  width?: number | null
  height?: number | null
  svgContent?: string | null
}

export const MASK_ACCENT = 'var(--color--accent, #b0b0b0)'

// The shape is painted as a background *behind* the mask rather than as an
// inline <svg>, so the artwork and the image placeholder are the same layer and
// every child of the box — fill, image, reveal image, text — is clipped by one
// mask. The box's aspect ratio is the viewBox's, which makes `contain` resolve
// to the full box: mask and content share a single coordinate frame.
export const useMaskStyle = (maskShape: MaskStyleShape) => {
  const image = maskShape.svgContent
    ? `url("data:image/svg+xml,${encodeURIComponent(maskShape.svgContent)}")`
    : `url(${maskShape.url})`

  return {
    aspectRatio: useMaskAspectRatio(maskShape) ?? '1 / 1',
    maskImage: image,
    maskSize: 'contain',
    maskRepeat: 'no-repeat',
    maskPosition: 'center',
    WebkitMaskImage: image,
    WebkitMaskSize: 'contain',
    WebkitMaskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
  }
}
